import React from "react";
import "./styles.css";
const BottomLayout = ({ isExceed, children }) => {
  if (isExceed) return <div className="bottom-support">{children}</div>;
  return <>{children}</>;
};

export default BottomLayout;
